import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DisplayPage, PageMode } from '../pages-manager.component';

@Component({
  selector: 'app-new-page-item',
  templateUrl: './new-page-item.component.html',
  styleUrls: ['./new-page-item.component.scss'],
  animations: [
    trigger('pageAnimation', [
      transition(':enter', [
        style({
          transform: 'translateY(2rem)',
          opacity: 0
        }),
        animate('0.3s ease-out')
      ])
    ])
  ]
})
export class NewPageItemComponent implements OnInit {
  @Input() page: DisplayPage;
  @Input() compact: boolean = true;
  @Input() mode: PageMode | 'add' = 'select';
  @Input() canLink: boolean;
  @Output() connect: EventEmitter<any>;
  @Output() disconnect: EventEmitter<void>;
  @Output() link: EventEmitter<void>;
  @Output() profile: EventEmitter<any>;

  constructor() {
    this.connect = new EventEmitter();
    this.disconnect = new EventEmitter();
    this.link = new EventEmitter();
    this.profile = new EventEmitter();
  }

  get name(): string {
    return (this.page?.channel === 'instagram' && this.page?.instagram_business_account?.name) || this.page?.exchangedData?.name || this.page?.name;
  }

  get pictureUrl(): string {
    return (
      (this.page?.channel === 'instagram' && this.page?.instagram_business_account?.profile_picture_url) ||
      (typeof this.page?.picture === 'string' ? this.page?.picture : this.page?.picture?.data?.url)
    );
  }

  ngOnInit() {}

  openPage(page: DisplayPage): void {
    window.open(`https://www.facebook.com/${page.id}`);
  }

  openMessenger(page: DisplayPage): void {
    window.open(`https://m.me/${page.id}`);
  }

  openModalProfile(page: DisplayPage): void {
    this.profile.emit(page.id);
  }

  connectPage(page: DisplayPage): void {
    this.connect.emit(page);
  }

  linkPage(): void {
    if (this.mode !== 'manage' || !!this.page.linkId || !this.canLink) return;
    this.link.emit();
  }

  disconnectPage(): void {
    if (this.mode !== 'manage') return;
    this.disconnect.emit();
  }
}
